import React from "react";
import Link from "next/link";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { PCPS_RESEARCH_DATA } from "@/lib/data/pcps-research";

const PcpsResearch = () => {
    // Show only the 3 most recent research posts on the homepage
    const RECENT_RESEARCH = PCPS_RESEARCH_DATA.slice(0, 3);

    return (
        <div
            className={cn(
                `2xl:p-[0_5rem] xl:p-[0_5rem] md:p-[0_3.125rem] `,
                `w-full max-w-[90rem] p-[0_1.25rem] clear-both m-[0_auto_2rem] xl:scroll-mt-28`
            )}
        >
            <section
                className={cn(
                    `xl:float-none xl:m-[6rem_auto_5rem] xl:min-h-[20rem] `,
                    `clear-both [float:inherit]`,
                    `md:m-[1.875rem_0] md:pb-[3.25rem]  md:min-h-[9.375rem]`,
                    `clear-both [float:inherit] m-[1.5625rem_0] pb-[4.0625rem] relative w-full z-[0]`,
                    `before:bg-[rgba(16,63,130,0.05)] before:absolute before:z-0 
                    before:h-auto before:top-[17.54vw] before:bottom-0 before:left-0 
                    before:pointer-events-none before:w-full`
                )}
            >
                {/* Vertical Heading */}
                <header
                    className={cn(
                        "absolute top-0 left-0",
                        "w-9 xl:w-12 border-b border-[#272727]",
                        "[writing-mode:vertical-lr] scale-[-1]"
                    )}
                >
                    <h2
                        className={cn(
                            "uppercase font-bold whitespace-nowrap leading-none",
                            "text-xs xl:text-2xl",
                            "tracking-widest pb-4"
                        )}
                    >
                        PCPS Research
                    </h2>
                </header>

                {/* Cards Wrapper */}
                <div
                    className={cn(
                        `xl:max-w-[75.625rem]
                            md:flex md:justify-center md:max-w-[90rem] md:p-0 md:w-[87.5%] 
                           items-baseline box-border m-auto 
                           p-[0_2.8125rem] relative w-full`
                    )}
                >
                    {RECENT_RESEARCH.map((item) => (
                        <Link
                            href={`/pcps-research` + item.href}
                            key={item.title.toLowerCase()}
                            title={item.title}
                            className={cn(`
                                    xl:basis-[20.625rem] xl:mr-[1.875rem] 
                                    xl:max-w-full
                                md:basis-[13.25rem] md:mr-[1.0625rem] inline-block 
                                basis-[14.5rem] m-[0_0_2rem] 
                                [text-decoration:none]
                                w-[14.5rem] z-[1] mr-[.5rem]
                                `)}
                        >
                            <Image
                                datatype={item.landingImage ? "landing" : "image"}
                                src={item.landingImage ? item.landingImage : item.image}
                                alt={item.title}
                                width={330}
                                height={408}
                                className={`md:mb-[1rem] md:max-h-fit h-fit mb-[0.9375rem] block max-w-full`}
                            />

                            {/* Meta */}
                            <span
                                className="flex flex-col md:flex-row gap-1 text-xs tracking-widest mb-2"

                            >
                                <p>{item.category}</p>
                                <p className={cn(
                                    `md:before:content-['|'] md:before:px-3 before:text-black`,
                                    {
                                        'text-primary-blue': item.type == "Article",
                                        'text-primary-red': item.type == "Research"
                                    }
                                )}>
                                    {item.type}
                                </p>
                            </span>

                            {/* Title */}
                            <span
                                className={`text-[1rem] leading-4 font-bold cursor-pointer text-[#272727] 
                relative m-0 transition-[color_0.35s_ease-out] hover:underline hover:underline-offset-2 decoration-[#A31F34] hover:decoration-2
                
                `}
                            >
                                {item.title}
                            </span>
                        </Link>
                    ))}
                </div>

                {/* View Other Research Button */}
                <div
                    className={cn(
                        `flex justify-center w-full mt-[2rem] xl:mt-[2.5rem]`
                    )}
                >
                    <Link
                        href="/pcps-research"
                        className={cn(
                            `inline-block [text-decoration:none] uppercase font-bold`,
                            `text-[0.875rem] tracking-[0.09375rem]`,
                            `px-[2rem] py-[0.75rem]`,
                            `border-2 border-[#A31F34] text-[#A31F34]`,
                            `transition-colors duration-300`,
                            `hover:bg-[#A31F34] hover:text-white`
                        )}
                    >
                        View Other Research
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default PcpsResearch;
